<div class="card w-full h-full flex flex-col shadow-sm p-6 rounded-2xl bg-white gap-8">
  <div class="flex flex-col">
    <h1 class="font-semibold text-2xl">Reporte de Ventas</h1>
    <p class="text-secondary-500">
      Usa los filtros para refinar el resumen de pedidos.
    </p>
  </div>

  <div class="flex flex-row flex-wrap justify-start gap-4 items-end">

    <div class="flex flex-col gap-1 relative z-30">
      <label class="text-xs font-semibold text-gray-600">Asesor Comercial</label>
      <input type="text" [(ngModel)]="filters.asesor"
        (input)="onSearchInput('asesor')"
        (focus)="onFocus('asesor')"
        (blur)="onBlur('asesor')"
        placeholder="Buscar asesor..."
        autocomplete="off"
        [disabled]="flowFromCliente"
        class="block w-70 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 hover:bg-secondary-75/50 focus:outline-none text-gray-800" />

      @if (showDropdown.asesor && suggestions.asesor.length > 0) {
      <ul class="absolute z-40 w-full bg-white border border-gray-300 top-full mt-1 shadow-lg max-h-40 overflow-auto rounded-md">
        @for (item of suggestions.asesor; track item.an) {
          <li (click)="selectSuggestion('asesor', item)" class="p-2 hover:bg-orange-100 cursor-pointer text-sm">
            {{ item.name }} ({{ item.an }})
          </li>
        }
      </ul>
      }
    </div>

    <div class="flex flex-col gap-1 relative z-20">
      <label class="text-xs font-semibold text-gray-600">Cliente</label>
      <input type="text" [(ngModel)]="filters.cliente"
        (input)="onSearchInput('cliente')"
        (focus)="onFocus('cliente')"
        (blur)="onBlur('cliente')"
        placeholder="Buscar cliente..."
        autocomplete="off"
        class="block w-80 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 hover:bg-secondary-75/50 focus:outline-none text-gray-800" />

      @if (showDropdown.cliente && suggestions.cliente.length > 0) {
      <ul class="absolute z-40 w-full bg-white border border-gray-300 top-full mt-1 shadow-lg max-h-40 overflow-auto rounded-md">
        @for (item of suggestions.cliente; track item.an) {
          <li (click)="selectSuggestion('cliente', item)" class="p-2 hover:bg-orange-100 cursor-pointer text-sm">
            {{ item.name }} ({{ item.an }})
          </li>
        }
      </ul>
      }
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-xs font-semibold text-gray-600">Tipo de material</label>

      <select
        [(ngModel)]="filters.tipoMaterial"
        (change)="findAll()"
        class="block w-60 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 hover:bg-secondary-75/50 focus:outline-none text-gray-800"
      >
        <option value="">Todos</option>
        <option value="AGLOMERADO">Aglomerado</option>
        <option value="MOLDURA">Moldura</option>
        <option value="FIBRA">Fibra</option>
        <option value="BORDOS">Bordos</option>
      </select>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-xs font-semibold text-gray-600">Fecha desde</label>
      <input
        type="date"
        [(ngModel)]="filters.fechaDesde"
        (change)="findAll()"
        class="block w-45 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 focus:outline-none text-gray-800"
      />
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-xs font-semibold text-gray-600">Fecha hasta</label>
      <input
        type="date"
        [(ngModel)]="filters.fechaHasta"
        (change)="findAll()"
        class="block w-45 border border-gray-400 rounded-sm py-2 px-3 bg-secondary-50 focus:outline-none text-gray-800"
      />
    </div>

    <div class="flex gap-2 mb-0.5">
      <app-button label="Limpiar filtros" color="red-500" icon="fi-rr-eraser" (click)="cleanFilter()"></app-button>
    </div>

  </div>

  @if (reportSummary) {
    <div class="mt-6 grid gap-4 grid-cols-1 sm:grid-cols-2">

      <div class="p-4 rounded-2xl bg-orange-100 border border-orange-300">
        <p class="text-xs uppercase tracking-wider text-orange-700">Pedidos facturados</p>
        <p class="text-2xl font-semibold text-orange-900">
          {{ reportSummary.invoicedOrdersCount ?? 0 }}
        </p>
      </div>

      <div class="p-4 rounded-2xl bg-sky-100 border border-sky-300">
        <p class="text-xs uppercase tracking-wider text-sky-700">Valor facturado</p>
        <p class="text-2xl font-semibold text-sky-900">
          ${{ (reportSummary.invoicedOrdersAmount ?? 0) | number:'1.2-2' }}
        </p>
      </div>

    </div>

    <section class="mt-4 p-5 rounded-2xl border border-orange-100 bg-orange-50/60 shadow-sm">
      <div class="flex items-center justify-between gap-2">
        <p class="text-sm font-semibold text-orange-700 uppercase tracking-wide">Totales confirmados</p>
        <span class="text-xs font-semibold text-orange-400 tracking-wide">UOM / Valor</span>
      </div>
      <div class="mt-4 space-y-3">
        @if (confirmedTotalsList.length > 0) {
          @for (item of confirmedTotalsList; track item.uom) {
            <div class="flex items-center justify-between rounded-xl px-4 py-2 bg-white border border-orange-100">
              <span class="text-sm font-medium text-secondary-600">{{ item.uom }}</span>
              <span class="text-lg font-semibold text-secondary-900">
                {{ item.value | number:'1.0-2' }}
              </span>
            </div>
          }
        } @else {
          <p class="text-sm text-orange-700">No hay totales confirmados disponibles.</p>
        }
      </div>
    </section>
    @if (showProformaSummary) {
      <div class="mt-4 grid gap-4 grid-cols-1 sm:grid-cols-2">
        <div class="p-4 rounded-2xl bg-emerald-100 border border-emerald-300">
          <p class="text-xs uppercase tracking-wider text-emerald-700">Pedidos proforma</p>
          <p class="text-2xl font-semibold text-emerald-900">
            {{ reportSummary.proformaOrdersCount ?? 0 }}
          </p>
        </div>

        <div class="p-4 rounded-2xl bg-purple-100 border border-purple-300">
          <p class="text-xs uppercase tracking-wider text-purple-700">Valor proforma</p>
          <p class="text-2xl font-semibold text-purple-900">
            ${{ (reportSummary.proformaOrdersAmount ?? 0) | number:'1.2-2' }}
          </p>
        </div>
      </div>
    }

    @if (showDraftTotals) {
      <div class="mt-6">
        <section class="p-5 rounded-2xl border border-emerald-200 bg-emerald-50/70 shadow-sm">
          <div class="flex items-center justify-between gap-2">
            <p class="text-sm font-semibold text-emerald-700 uppercase tracking-wide">Totales borrador</p>
            <span class="text-xs font-semibold text-emerald-400 tracking-wide">UOM / Valor</span>
          </div>
          <div class="mt-4 space-y-3">
            @if (draftTotalsList.length > 0) {
              @for (item of draftTotalsList; track item.uom) {
                <div class="flex items-center justify-between rounded-xl px-4 py-2 bg-white border border-emerald-100">
                  <span class="text-sm font-medium text-emerald-700">{{ item.uom }}</span>
                  <span class="text-lg font-semibold text-emerald-900">
                    {{ item.value | number:'1.0-2' }}
                  </span>
                </div>
              }
            } @else {
              <p class="text-sm text-emerald-700">No hay totales en borrador disponibles.</p>
            }
          </div>
        </section>
      </div>
    }
  } @else {
  <div class="bg-yellow-100 p-4 rounded-2xl text-yellow-800 flex items-center gap-2">
    <i class="fi-rr-info text-xl"></i>
    <span>No hay datos para los filtros seleccionados.</span>
  </div>
  }
</div>
